import { REQUEST_REPORT_UPDATE_V2, REQUEST_REPORT_V2 } from 'constants/routePaths';

import * as React from 'react';

import { EditCalendar } from '@mui/icons-material';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import CloneReportIcon from 'components/Icons/ReportIcons/CloneReportIcon';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import selectTokenRoles from 'selectors/sessionTokenRoles';
import { hasSuperAdminRole } from 'utils/roleUtils';

interface Props {
  handleClose: () => void;
  report: reports.AllReportsQueryRow;
}

/** Opens Report Request V2 prefilled from `report`. */
export const CloneReportV2MenuItem: React.FC<Props> = ({ handleClose, report }) => {
  const { t } = useTranslation();
  return (
    <MenuItem
      onClick={handleClose}
      component={Link}
      to={{ pathname: REQUEST_REPORT_V2, state: { templateReport: report } }}
    >
      <ListItemIcon>
        <CloneReportIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText primary={t('reportsQa.menu.cloneReportV2')} />
    </MenuItem>
  );
};

/** Opens the Report Request V2 update flow for `report`. Super admins only. */
export const UpdateReportV2MenuItem: React.FC<Props> = ({ handleClose, report }) => {
  const { t } = useTranslation();
  const isSuperAdmin = hasSuperAdminRole(useSelector(selectTokenRoles));
  if (!isSuperAdmin) return null;
  return (
    <MenuItem
      onClick={handleClose}
      component={Link}
      to={{ pathname: REQUEST_REPORT_UPDATE_V2, state: { templateReport: report } }}
    >
      <ListItemIcon>
        <EditCalendar fontSize="small" color="primary" />
      </ListItemIcon>
      <ListItemText primary={t('reportsQa.menu.updateReportV2')} />
    </MenuItem>
  );
};
